<template>
    <img class="img" src="@/assets/images/policy_match.png" />
    <div class="header">
        <div class="title small">
            <span class="level" v-if="detail.article.policy_level&&detail.article.policy_level==0">[国]</span>
            <span class="level" v-if="detail.article.policy_level&&detail.article.policy_level==1">[省]</span>
            <span class="level" v-if="detail.article.policy_level&&detail.article.policy_level==2">[市]</span>
            <span class="level" v-if="detail.article.policy_level&&detail.article.policy_level==3">[区县]</span>
            <span class="level" v-if="detail.article.policy_level&&detail.article.policy_level>3">[其他]</span>
            {{ detail.title }}
            </div>
        <div class="match-detail small">
            <div class="field-normal">
                <div class="field-item">
                    <span class="field-label">阅读量:</span>
                    <span class="field-value">{{ detail.click_num || 0 }}</span>
                </div>
                <div class="field-item">
                    <span class="field-label">收藏量:</span>
                    <span class="field-value">{{detail.favorite_num}}</span>
                </div>
                <div class="field-item" v-if="type != '1' && detail.expire_date">
                    <span class="field-label">日期:</span>
                    <span class="field-value">{{ detail.expire_date }}</span>
                </div>
                <div class="field-item address"  v-if="detail.article && detail.article.dispatch_name">
                    <span class="field-label"> 发文部门:</span>
                    <span class="field-value">{{ detail.article.dispatch_name}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PolicyDetailHeader',
    data(){
        return {
        }
    } ,
    props: {
        detail: {
            type: Object,
            default: {}
        },
        type: {
            type: String,
            default: ''
        }
    },
}
</script>
